<template>
  <div class="input-upload">
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="80px">
      <el-form-item :label="labelName" prop="keyWord">
        <el-input
          v-model.trim="form.keyWord"
          :placeholder="`请输入${labelName}`"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: "InputUpload",
  components: {},
  mixins: [],
  props: {
    labelName: {
      type: String,
      default: "企业名称"
    }
  },
  data() {
    return {
      form: {
        keyWord: ""
      },
      rules: {
        keyWord: [
          { required: true, message: `请输入${this.labelName}`, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    submitForm() {
      let flag = true;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          flag = true;
        } else {
          flag = false;
          return false;
        }
      });
      return flag ? this.form : null;
    }
  }
};
</script>
<style lang="less" scoped>
.input-upload {
  padding: 20px;
}
</style>
